import { connect, useSelector, useDispatch, } from 'react-redux';
import { getIsVerificationNeeded } from '../publicSession/selectors';
import { useCallback } from 'react';
import { pushVerificationPopup } from './actions';
import noop from '../utils/noop';
import { useRestrictToLoggedIn } from '../utils/hooks/useRestrictToLoggedIn';
var mapStateToProps = function (state) { return ({
    isVerificationNeeded: getIsVerificationNeeded(state),
}); };
var mapDispatchToProps = {
    pushVerificationPopup: pushVerificationPopup,
};
export function withVerification(component) {
    return connect(mapStateToProps, mapDispatchToProps)(component); // redux types are not fond of generics
}
export function useVerification() {
    var isVerificationNeeded = useSelector(getIsVerificationNeeded);
    var _a = useRestrictToLoggedIn(), isLoggedIn = _a.isLoggedIn, sendUserToJoinPage = _a.sendUserToJoinPage;
    var dispatch = useDispatch();
    var pushVerificationPopupCallback = useCallback(function (actionType) {
        return dispatch(pushVerificationPopup(actionType));
    }, [dispatch]);
    var restrictToVerified = useCallback(function (actionType, callback) {
        if (callback === void 0) { callback = noop; }
        return function () {
            return isVerificationNeeded
                ? pushVerificationPopupCallback(actionType)
                : callback();
        };
    }, [pushVerificationPopupCallback, isVerificationNeeded]);
    var restrictToVerifiedAndLoggedIn = useCallback(function (restrictedActionName, actionType, callback) {
        if (callback === void 0) { callback = noop; }
        return function () {
            return isLoggedIn
                ? isVerificationNeeded
                    ? pushVerificationPopupCallback(actionType)
                    : callback()
                : sendUserToJoinPage(restrictedActionName);
        };
    }, [
        isLoggedIn,
        isVerificationNeeded,
        pushVerificationPopupCallback,
        sendUserToJoinPage,
    ]);
    return {
        isVerificationNeeded: isVerificationNeeded,
        pushVerificationPopup: pushVerificationPopupCallback,
        restrictToVerified: restrictToVerified,
        restrictToVerifiedAndLoggedIn: restrictToVerifiedAndLoggedIn,
    };
}
//# sourceMappingURL=withVerification.js.map